import axios from './axios';

export default (designId, itemId, configurationGuid) => (
  axios.post(
    `/designs/${designId}/items/${itemId}/product`,
    { configurationGuid },
  )
);
